var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgFacebook(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "#4460A0",
    d: "M16.546 24H8.883A.883.883 0 018 23.117V8.883C8 8.395 8.395 8 8.883 8h14.234c.488 0 .883.395.883.883v14.234a.883.883 0 01-.883.883H19.04v-6.196h2.08l.31-2.415h-2.39v-1.541c0-.7.194-1.176 1.196-1.176h1.28v-2.16a16.99 16.99 0 00-1.864-.095c-1.844 0-3.106 1.125-3.106 3.191v1.781h-2.085v2.415h2.085V24z"
  }));
}

export default SvgFacebook;